import ActionTypes from '@constants/action_types.js'

export function receiveCategories(categories) {
  return {
    type: ActionTypes.RECEIVE_CATEGORIES,
    payload: categories,
  }
}
